import {
  EyeStroke,
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onRefreshClick?: () => void;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshClick
}) => {
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục loại TSCĐ, CCDC</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} />
      <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Làm mới' onClick={onRefreshClick} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
